import React, { Component, Fragment } from "react";
import { themeService } from "../../../theme/service/activeTheme.service";
import { Col } from "reactstrap";
import { CRUDFunction } from "reduxCURD/container";
import NewCPCrossingReport from "../CP/NewCrossingReport/CP_CrossingReport";
// import { curdActions } from "reduxCURD/actions";
// import { switchReportStyle } from "./style/index";
// import { formFeildStyle } from "../../../wigets/forms/style/formFields";
import { languageService } from "Language/language.service";
import { getAssetTree } from "../../../reduxRelated/actions/assetHelperAction";
import moment from "moment";
import SvgIcon from "react-icons-kit";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import { getUserSignature, userListRequest, getAllUsersList } from "../../../reduxRelated/actions/userActions";

import { printer } from "react-icons-kit/icomoon/printer";
import _ from "lodash";
import { SelectField } from "../Timps/reportfilter";
import { trackReportStyle } from "../Timps/style";
import InputDateField from "../Timps/inputdateField";
import ReportSelection from "./reportSelection";
import SpinnerLoader from "../../Common/SpinnerLoader";
import GI303Report from "./maintenance-303";
import GI305Report from "./maintenance-305a";
import GI303BatteryMaintenance from "./batteryMaintenance";
import GI303B12B24BatteryTestReports from "./batteryTestReportsB12&B24.jsx";
import SudNicmanReport from "./sudNicman";
import DefaultReport from "./Default/fRADefaultReport";
import { getCustomer, SUPPORTED_CUSTOMERS, versionInfo } from "../../MainPage/VersionInfo";
import RelayTest from "./relayTest";
import InsulationResistance from "./insulationResistance";

import HighWayCrossing from "./highWayCrossingCombined/highWayCrossing";
import CrossingWarning from "./ontario/crossingWarning";
import DateRangeControl, { rangeCalculater } from "../../Common/DateRange/DateRangeControl";
import { updateFilterState } from "reduxRelated/actions/filterStateAction";
import { getCurrentReportStateFilters, TEMPLATE_REPORT_FILTERS } from "./HelperFunctions/stateRetentionManagement";
import FRACrossingReport from "./FRA_Crossing/FRA_CrossingReport";
import { calculateCombineSets } from "./CombineMethods/CombineMethods";
import SFRTA_LockingTestsAndInspectionsReport from "../SFRTA/LockingTestsAndInspectionsReport";
import SFRTA_BridgeTestsAndInspectionReport from "../SFRTA/BridgeTestsAndInspectionReport";
import ONR_GenericTestsReport from "../ONR/GenericTestsReport";
import BatteryCardReports from "./FRA_Crossing/BatteryCardReport/BatteryCardReports";
import SFRTA_DefectDetectorTestsAndInspectionsReport from "../SFRTA/DefectDetectorTestsAndInspectionsReport";
import SFRTA_GradeCrossingActivationFailureReport from "../SFRTA/GradeCrossingActivationFailureForm";
import SFRTA_SignalIncidentResponseRecord from "../SFRTA/SignalIncidentResponseRecord";
import SFRTA_SwitchTestsAndInspectionsReport from "../SFRTA/SwitchTestsAndInspectionsReport";
import ATLAS_InspectionConnectionReport from "../ATLAS/InspectionConnectionReport";
import ONR_SwitchTestsAndInspectionsReport from "../ONR/SwitchTestsAndInspectionsReport/index.jsx";
import LIRR_HighwayGradeCrossingReport from "../LIRR/HighwayGradeCrossing/index.jsx";
import NYSW_SignalIncidentResponseRecord from "../NYSW/SignalIncidentResponseRecord/index.jsx";
import LIRR_SwitchTestsAndInspectionReport from "../LIRR/SwitchTestAndInspection/index.jsx";
import HDBReport from "../ONR/HBDReport/index.jsx";
import { isFraRole } from "../../MainPage/UserInfo.js";
import { DefaultChecklistReports } from "../ReVAMP/Periodic/CheckListReports.jsx";
import { LomotiveInspection33daysReport } from "../ReVAMP/LomotiveInspection33days/LomotiveInspection33days.jsx";
import { DailyLocomotiveReports } from "../ReVAMP/DailyLocomotiveInspection/DailyLocomotiveReport.jsx";
import { WaiverReports } from "../ReVAMP/WaiverReport/WaiverReport.jsx";
import { MainReservoirReport } from "../ReVAMP/MainReservoirTest/MainReservoirTest.jsx";
import { NonCompliantLocomotiveReport } from "../ReVAMP/NonCompliantLocomotiveReport/NonCompliantLocomotiveReport.jsx";
import { NonCompliantLocomotiveBackToService } from "../ReVAMP/NonCompliantLocomotiveBackToService/NonCompliantLocomotiveBackToService.jsx";
import NonComplaintReport from "../ReVAMP/NonComplaintMaintanence/NonComplaintMaintanence.jsx";
import { ToastService } from "../../../utils/toastify.js";
import { inspectionReportList, refreshOnReturnReportList } from "./reportFilter_SITE_Variables.js";
import LocomotiveCheckOffList from "../ReVAMP/LocomotiveCheckOffList/LocomotiveCheckOffList.jsx";
import ETR_WeeklyReport from "../ETR/WeeklyReport/index.jsx";
import OEMSingleReportContainer from "../ReVAMP/OEMSingleReport/OEMSingleReport.jsx";
import ETRInspectionCard62590Report from "../ETR/InspectionCard62590Report/index.jsx";
import ETRGCPReport from "../ETR/GCPReport/index.jsx";
import { AirBrakeReports } from "../ReVAMP/AirBrakeReports/AirBrakeReport.jsx";
import { getGroupReportLookup } from "../../../reduxRelated/actions/groupReportActions.js";
import ShiftedLoadDetectorReport from "../HighBall/ShiftedLoadDetector/index.jsx";
import HighBallHBDReport from "../HighBall/HBDReport/index.jsx";
import { Path_92daysInspectionReport } from "../ReVAMP/PATH/92daysReport/index.jsx";
import FGA_DefectDetectorTestsAndInspectionsReport from "../SFRTA/FGADefectDetectorTestsAndInspectionsReport/index.jsx";
// import SDMTSInspectionReport from "../SDMTS/InspectionReportForm/index.jsx";
import BIAnnualTestReport from "../SDMTS/BIAnnualTest/index.jsx";
import { curdActions } from "../../../reduxCURD/actions.js";
import SDMTSInspectionReport from "../SDMTS/InspectionReportForm/index.jsx";
import TripStopReport from "../PATH/TripStopReport/index.jsx";
import TrackCircuitReport from "../PATH/TrackCircuitReport/index.jsx";
import SEIII_TrackCircuitReport from "../PATH/TrackCircuitReport/SEIII/index.jsx";
import DigiCodeRev5TrackCircuit_Report from "../PATH/TrackCircuitReport/DigicodeRev5TrackCircuit/index.jsx";
import ST_1_DigiCodeTrackCircuit_Report from "../PATH/TrackCircuitReport/ST-1_DigiCodeTrackCircuit/index.jsx";
import LogicUnitValues from "../Columbia/Columbia Site/index.jsx";
import { GradeCrossingAccidentReport } from "../HighBall/GradeCrossingAccidentReport/index.jsx";
import { Path_12daysInspectionReport } from "../ReVAMP/PATH/12MonthsReport/index.jsx";
import { Path_24daysInspectionReport } from "../ReVAMP/PATH/24MonthsReport/index.jsx";
import { Path_36daysInspectionReport } from "../ReVAMP/PATH/36MonthsReport/index.jsx";

const defaultReportNames = {
  gi329f: "GI329",
  gi334f: "GI334",
  scp901f: "SCP901",
  scp902f: "SCP902",
  scp907f: "SCP907",
  gi329fa: "GI329a",
  gi329fb: "GI329b",
  gi329fc: "GI329c",
  gi329fd: "GI329d",
  gi313f: "GI313",
};
const InputObj = {
  location: "",
  assetType: "",
  test: "",
};
class testReportFilter extends Component {
  constructor(props) {
    super(props);
    this.reportSRFilter = getCurrentReportStateFilters(this.props.reportSRFilter);
    this.state = {
      assetTypeOptions: [],
      locationOptions: [],
      testsOptions: [],
      reportTypeOptions: [],
      selectedAsset: "",
      selectedAssetId: null,
      assetTestEntries: [],
      showReport: false,
      dateRange: {
        from: new Date(moment().startOf("month")),
        today: new Date(moment().startOf("day")),
        to: new Date(moment().endOf("month")),
      },
      InputObj: { ...InputObj },
      reports: [],
      reportDetailData: [],
      reportCode: "",
      spinnerLoading: false,
      testSchedules: [],
      selectedReportItem: {},
      selectedReport: null,
      reviewReqIds: [],
      selectedAssetComplete: null,
      ...this.reportSRFilter,
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.updateDateRange = this.updateDateRange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.printReport = this.printReport.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.isApp = this.isApp.bind(this);
    this.renderReportDisplay = this.renderReportDisplay.bind(this);
    this.handleUpdateFilterState = this.handleUpdateFilterState.bind(this);
    this.getReportSchedules = this.getReportSchedules.bind(this);
    this.showReportFromDashboard = this.showReportFromDashboard.bind(this);
    this.filterOutReports = this.filterOutReports.bind(this);
    this.calculateFilterData = this.calculateFilterData.bind(this);
  }

  handleUpdateFilterState(propertiesToUpdate) {
    let reportSRFilter = this.props.reportSRFilter ? this.props.reportSRFilter : {};

    this.props.updateFilterState("reportSRFilter", {
      ...reportSRFilter,
      ...propertiesToUpdate,
    });
  }
  isApp = () => localStorage.getItem("source");
  getRangeDataFromServer(range, additionalQuery, inspecSchedule) {
    const queryParams = { ...range, inspecSchedule: inspecSchedule ? inspecSchedule : this.state.pInspecSchedule };

    var jsonArray = encodeURIComponent(JSON.stringify(queryParams));
    let arg = "?dateRange=" + jsonArray + (additionalQuery ? additionalQuery : "");
    this.props.getTestSchedules("/getReportFilter" + arg);
  }
  changeHandler(e, blur) {
    let InputObj = { ...this.state.InputObj };
    InputObj[e.target.name] = e.target.value;
    let assetReports = [];
    if (e.target.name == "assetType") {
      assetReports = this.filterByVals(
        e.target.value,
        this.state.InputObj.location,
        this.state.InputObj.test,
        this.state.InputObj.reportType,
      );
    }
    if (e.target.name == "location") {
      assetReports = this.filterByVals(
        this.state.InputObj.assetType,
        e.target.value,
        this.state.InputObj.test,
        this.state.InputObj.reportType,
      );
    }
    if (e.target.name == "test") {
      assetReports = this.filterByVals(
        this.state.InputObj.assetType,
        this.state.InputObj.location,
        e.target.value,
        this.state.InputObj.reportType,
      );
    }

    if (e.target.name == "reportType") {
      assetReports = this.filterByVals(
        this.state.InputObj.assetType,
        this.state.InputObj.location,
        this.state.InputObj.test,
        e.target.value,
      );
    }

    this.setState({
      InputObj: InputObj,
      reports: assetReports,
    });
  }

  filterByVals(assetType, location, test, reportType, testSchedules) {
    let assetReports = testSchedules ? [...testSchedules] : [...this.state.testSchedules];
    assetReports = _.filter(assetReports, (testSch) => {
      // default to true if all
      let aTypeCheck = assetType == "All" ? true : false;
      let locationCheck = location == "All" ? true : false;
      let testCheck = test == "All" ? true : false;
      let reportTypeCheck = reportType == "All" ? true : false;
      // check if not true by default then calculate its validity
      !aTypeCheck && (aTypeCheck = testSch.assetType == assetType);
      !locationCheck && (locationCheck = testSch.lineId == location);
      !testCheck && (testCheck = testSch.testDescription == test);
      if (!reportTypeCheck) {
        if (reportType == "All Reviews") {
          reportTypeCheck = testSch.reviewCom || testSch.reviewReq;
        } else if (reportType == "Pending Review") {
          reportTypeCheck = testSch.reviewReq;
        } else if (reportType == "Completed Review") {
          reportTypeCheck = testSch.reviewCom;
        }
      }
      return aTypeCheck && locationCheck && testCheck && reportTypeCheck;
    });
    return assetReports;
  }
  updateDateRange(dateRange, stateRange, inspecSchedule) {
    this.setState({
      dateRange: dateRange,
      pInspecSchedule: inspecSchedule,
      ...stateRange,
    });
    this.handleUpdateFilterState({
      dateRange: dateRange,
    });
    let additionalQuery = isFraRole() ? "&isFra=" + isFraRole() : null;
    this.getRangeDataFromServer(dateRange, additionalQuery, inspecSchedule);
  }
  // _.cloneDeep
  filterOutReports(reports, assetId, reportCode, combinedSets) {
    let report = reports.filter((e) => e.assetId === assetId && e.testCode === reportCode);
    if (report.length > 0) {
      this.handleClick(report[0], combinedSets);
    } else {
      //redirect to "/dashboard"
      ToastService.Error("No Report Found", "");
      this.props.history.goBack();
    }
  }
  showReportFromDashboard(assetId, reportCode) {
    let dateRange = this.getPast12MonthsDateRange();
    this.setState({
      dateRange: dateRange,
      pInspecSchedule: "Scheduled",
    });

    this.getRangeDataFromServer(dateRange, null, "Scheduled");
  }

  componentDidMount() {
    if (this.props.selectedReport) {
      const { assetId, reportCode } = this.props.selectedReport;
      if (assetId == "" || reportCode == "") return;
      this.setState({
        selectedAsset: "Locomotive",
        selectedAssetId: assetId,
        selectedAssetType: "Locomotive",
        selectedReport: { ...this.props.selectedReport },
      });
      this.showReportFromDashboard(assetId, reportCode);
    } else {
      this.state.pRange && this.state.submit && this.getRangeDataFromServer(this.state.dateRange);
    }
    const { getGroupReportLookup } = this.props;
    getGroupReportLookup && getGroupReportLookup("ReportGroupingLookup");
  }
  handleBack() {
    this.setState({
      showReport: false,
      selectedAsset: "",
      selectedAsset: null,
      reportDetailData: [],
      reviewReqIds: [],
    });
    // this.handleUpdateFilterState({
    //   showReport: false,
    //   selectedAsset: "",
    //   //reportDetailData: [],
    // });

    if (refreshOnReturnReportList.includes(this.state.reportCode)) {
      this.getRangeDataFromServer(this.state.dateRange);
    }
  }
  printReport() {
    document.title = this.state.reportDescription ? this.state.reportDescription : "SITE Report";
    window.print();
    let timpsSignalApp = versionInfo.isSITE();
    //window.onafterprint = function (event) {
    document.title = timpsSignalApp ? "SITE" : versionInfo.isBridge() ? "BIS" : "TIMPS";
    //};
  }

  checkCombinedStoredSet(combinedStoredSets, item) {
    let found = combinedStoredSets[item.id];
    // for (let sets of combinedStoredSets) {
    //   if (!found) found = _.find(sets, { id: item.id });
    // }
    return found ? item : null;
  }
  handleClick(item, combinedSets) {
    let additionalQuery = "&assetId=" + item.assetId + "&status=exec";
    let combineItemFound = this.checkCombinedStoredSet(combinedSets ? combinedSets : this.state.combinedSets, item);
    let dateRange = this.state.dateRange;
    if (combineItemFound) {
      for (let code of combineItemFound.testCodes) {
        //why
        additionalQuery = additionalQuery + "&testCodes=" + code;
      }
    } else {
      additionalQuery = additionalQuery + "&testCodes=" + item.testCode;
      if (item.enforceFormIds && item.enforceFormIds.length > 0) {
        for (let code of item.enforceFormIds) {
          additionalQuery = additionalQuery + "&testCodes=" + code;
        }
      }
    }
    if (inspectionReportList.includes(item.testCode)) additionalQuery += "&inspections=true";
    this.getRangeDataFromServer(dateRange, additionalQuery);
    this.setState({
      showReport: true,
      reportCode: item.testCode,
      reportDescription: item.testDescription,
      selectedAsset: item.assetName,
      selectedAssetType: item.assetType,
      selectedAssetId: item.assetId,
      selectedReportItem: item,
      selectedReport: null,
    });
  }

  getReportSchedules(item) {
    let additionalQuery = "&assetId=" + item.assetId + "&status=exec";
    let combineItemFound = this.checkCombinedStoredSet(this.state.combinedSets, item);
    let dateRange = this.state.dateRange;
    if (combineItemFound) {
      for (let code of combineItemFound.testCodes) {
        //why
        additionalQuery = additionalQuery + "&testCodes=" + code;
      }
    } else {
      additionalQuery = additionalQuery + "&testCodes=" + item.testCode;
      if (item.enforceFormIds && item.enforceFormIds.length > 0) {
        for (let code of item.enforceFormIds) {
          additionalQuery = additionalQuery + "&testCodes=" + code;
        }
      }
    }

    if (inspectionReportList.includes(item.testCode)) additionalQuery += "&inspections=true";

    this.getRangeDataFromServer(dateRange, additionalQuery);
  }

  calculateFilterData(testSchedulesData, getUserSignatureMethod, userListRequestMethod) {
    const { groupReportLookup } = this.props;
    let locationOptions = [];
    let assetTypeOptions = [];
    let testsOptions = [];
    let reportTypeOptions = [
      { val: "All", text: "All" },
      { val: "All Reviews", text: "All Reviews" },
      { val: "Pending Review", text: "Pending Review" },
      { val: "Completed Review", text: "Completed Review" },
    ];
    let combinedSets = calculateCombineSets(testSchedulesData, groupReportLookup);

    let stateToRet = {};
    let testSchedules = combinedSets.remainingTestScheds;
    if (testSchedules && _.isArray(testSchedules)) {
      if (getCustomer() === SUPPORTED_CUSTOMERS.CN) {
        testSchedules.map((report) => {
          if (report.testCode === "HighwayGradeCrossing") {
            report.testDescription = report.assetType;
          }
          return report;
        });
      }
      locationOptions.push({ val: "All", text: "All" });
      assetTypeOptions.push({ val: "All", text: "All" });
      testsOptions.push({ val: "All", text: "All" });
      testSchedules.forEach((test) => {
        checkFilledPush(test.lineId, locationOptions, test.lineName);
        checkFilledPush(test.assetType, assetTypeOptions);
        checkFilledPush(test.testDescription, testsOptions, test.testDescription);
      });
      const InputObj = {
        location: (this.state.InputObj && this.state.InputObj.location) || locationOptions[0].val,
        assetType: (this.state.InputObj && this.state.InputObj.assetType) || assetTypeOptions[0].val,
        test: (this.state.InputObj && this.state.InputObj.test) || testsOptions[0].val,
        reportType: (this.state.InputObj && this.state.InputObj.reportType) || reportTypeOptions[0].val,
      };

      stateToRet = {
        locationOptions,
        assetTypeOptions,
        testsOptions,
        reportTypeOptions,
        InputObj: InputObj,
        testSchedules: _.cloneDeep(testSchedules),
        spinnerLoading: false,
        combinedSets: combinedSets.combinedSet,
        reports: this.filterByVals(InputObj.assetType, InputObj.location, InputObj.test, InputObj.reportType, testSchedules),
      };
      getUserSignatureMethod && getUserSignatureMethod();
      userListRequestMethod && userListRequestMethod();
    } else {
      stateToRet = {
        spinnerLoading: false,
      };
    }
    return stateToRet;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.userActionType !== prevProps.userActionType && this.props.userActionType === "ALL_USER_LIST_REQUEST") {
      this.setState({
        spinnerLoading: true,
      });
    }
    if (this.props.userActionType !== prevProps.userActionType && this.props.userActionType === "ALL_USER_LIST_SUCCESS") {
      this.setState({
        spinnerLoading: false,
      });
    }

    if (this.props.userActionType !== prevProps.userActionType && this.props.userActionType === "ALL_USER_LIST_FAILURE") {
      this.setState({
        spinnerLoading: false,
      });
    }
    if (this.props.actionType == "TESTSCHEDULES_READ_REQUEST" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: true,
      });
    }
    if (this.props.actionType == "TESTSCHEDULES_READ_SUCCESS" && this.props.actionType !== prevProps.actionType && !this.state.showReport) {
      let stateToSet = this.calculateFilterData(this.props.testSchedules, this.props.getUserSignature, this.props.getAllUsersList);
      this.setState(stateToSet);
      if (this.state.selectedReport) {
        const { assetId, reportCode } = this.state.selectedReport;
        const { reports, combinedSets } = stateToSet;
        this.filterOutReports(reports, assetId, reportCode, combinedSets);
      }
    } else if (
      this.props.actionType == "TESTSCHEDULES_READ_SUCCESS" &&
      this.props.actionType !== prevProps.actionType &&
      this.state.showReport
    ) {
      let testSchedules = _.cloneDeep(this.props.testSchedules);
      if (this.state.reviewReqIds.length > 0) {
        testSchedules = this.props.testSchedules.map((t) => {
          if (this.state.reviewReqIds.includes(t._id)) {
            return {
              ...t,
              skipReviewFilter: true,
            };
          }
          return t;
        });
      }
      this.setState({
        reportDetailData: testSchedules.sort((a, b) => new Date(b.date) - new Date(a.date)),
        spinnerLoading: false,
      });
    }
    if (this.props.actionType == "TESTSCHEDULES_READ_FAILURE" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: false,
      });
    }

    if (this.props.actionType == "TESTSCHEDULE_UPDATE_SUCCESS" && this.props.actionType !== prevProps.actionType) {
      let reviewReqIds = [...this.state.reviewReqIds, ...this.props.testSchedule];
      this.setState({
        reviewReqIds: reviewReqIds,
      });
      this.getReportSchedules(this.state.selectedReportItem);
    }
    if (this.state.selectedAssetId !== prevState.selectedAssetId && this.state.selectedAssetId) {
      this.props.getAsset && this.props.getAsset(this.state.selectedAssetId);
    }
    if (this.props.assetActionType !== prevProps.assetActionType && this.props.assetActionType === "ASSET_READ_SUCCESS") {
      this.setState({
        selectedAssetComplete: this.props.asset,
      });
    }
  }

  renderReportDisplay(param) {
    return siteReportSelctor(
      param,
      this.state.reportDetailData,
      this.state.selectedAsset,
      this.state.selectedAssetId,
      this.props.usersSignatures,
      this.props.allUsers,
      this.state.selectedAssetType,
      this.props.updateTestSchedule,
      this.state.InputObj.reportType,
      this.state.selectedAssetComplete,
    );
  }
  getPast12MonthsDateRange() {
    const now = new Date();
    const today = new Date(now);
    today.setHours(23, 59, 59, 999);

    const from = new Date(now);
    from.setMonth(now.getMonth() - 12);
    from.setDate(1);
    from.setHours(0, 0, 0, 0);

    return {
      from: from.toISOString(),
      to: today.toISOString(),
      today: now.toISOString(),
    };
  }
  render() {
    //console.log(this.state.reportDetailData);
    const { from, to } = this.state.dateRange ? this.state.dateRange : {};
    const modifiers = { start: from, end: to };
    let modelRendered = <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />;
    const isReVAMP = versionInfo.isReVAMP();
    const PageTitle = isReVAMP ? "Locomotive Test Reports" : "Fixed Assets Tests Reports";
    return (
      <div>
        {modelRendered}
        {!this.state.showReport && (
          <div className="mainContent" style={{ textAlign: "center" }}>
            <Col md={12}>
              <div className="mainContent commonform" style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
                {
                  <React.Fragment>
                    <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
                      {languageService(PageTitle)}
                    </h2>
                    <span>
                      <DateRangeControl
                        dateRangeChanged={this.updateDateRange}
                        handleUpdateFilterState={this.handleUpdateFilterState}
                        iPeriod={this.state.iPeriod}
                        year={this.state.year}
                        pRange={this.state.pRange}
                        pInspecSchedule={this.state.pInspecSchedule}
                        submit={this.state.submit}
                        includeScheduleOption={!isReVAMP}
                        includePeriod={true}
                      />
                    </span>
                    {/* <label style={themeService(trackReportStyle.labelStyle)}>{languageService("Select a Date Range")}</label>
                    <span style={themeService(trackReportStyle.dateStyle)}>
                      <InputDateField updateDateRange={this.updateDateRange} defaultDate={this.state.dateRange} />
                    </span> */}
                    {this.state.locationOptions && this.state.locationOptions.length > 0 && (
                      <SelectField
                        inputFieldProps={{ name: "location", label: "Location" }}
                        options={this.state.locationOptions}
                        changeHandler={this.changeHandler}
                        value={this.state.InputObj.location}
                      />
                    )}

                    {this.state.assetTypeOptions && this.state.assetTypeOptions.length > 0 && (
                      <SelectField
                        inputFieldProps={{ name: "assetType", label: "AssetType" }}
                        options={this.state.assetTypeOptions}
                        changeHandler={this.changeHandler}
                        value={this.state.InputObj.assetType}
                      />
                    )}
                    {this.state.testsOptions && this.state.testsOptions.length > 0 && (
                      <SelectField
                        inputFieldProps={{ name: "test", label: "Tests" }}
                        options={this.state.testsOptions}
                        changeHandler={this.changeHandler}
                        value={this.state.InputObj.test}
                      />
                    )}

                    {this.state.reportTypeOptions && this.state.reportTypeOptions.length > 0 && !isReVAMP && (
                      <SelectField
                        inputFieldProps={{ name: "reportType", label: languageService("Report Type") }}
                        options={this.state.reportTypeOptions}
                        changeHandler={this.changeHandler}
                        value={this.state.InputObj.reportType}
                      />
                    )}
                  </React.Fragment>
                }
              </div>
            </Col>
            <ReportSelection reports={this.state.reports} handleClick={this.handleClick} reportType={this.state.InputObj.reportType} />
          </div>
        )}

        {this.state.showReport && (
          <React.Fragment>
            <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
              <div
                className="report-arrow"
                style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                onClick={(e) => {
                  this.handleBack();
                }}
              >
                <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Reports Menu")}
                </span>
                <SvgIcon icon={arrowLeft} size={24} />
              </div>

              {
                <div
                  className="report-print"
                  style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                  onClick={(e) => {
                    this.printReport();
                  }}
                >
                  <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                    {languageService("Print Report")}
                  </span>
                  <SvgIcon icon={printer} size={24} />
                </div>
              }
            </div>
            {this.state.reportCode && this.renderReportDisplay(this.state.reportCode)}
          </React.Fragment>
        )}
      </div>
    );
  }
}

let variables = {
  assetReducer: { asset: [], assets: {} },
  filterStateReducer: {
    reportSRFilter: null,
  },
  userReducer: {
    usersSignatures: [],
    allUsers: [],
  },
  diagnosticsReducer: {
    groupReportLookup: [],
  },
};
const getAsset = curdActions.getAsset;
let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: {
    updateFilterState,
    getUserSignature,
    getGroupReportLookup,
    getAllUsersList,
    getAsset,
  },
};
const testReportFilterContainer = CRUDFunction(testReportFilter, "testSchedule", actionOptions, variables, [
  "filterStateReducer",
  "userReducer",
  "diagnosticsReducer",
  "assetReducer",
]);

export default testReportFilterContainer;

export function checkFilledPush(field, existingArray, text, val) {
  let fieldFilled = _.find(existingArray, { val: field });
  if (!fieldFilled) {
    existingArray.push({ val: val ? val : field, text: text ? text : field });
  }
}

export function siteReportSelctor(
  param,
  reportDetailData,
  selectedAsset,
  selectedAssetId,
  usersSignatures,
  userList,
  assetType,
  updateTestSchedule,
  reportType,
  selectedAssetComplete,
) {
  const obj = {
    formFicheB12B24: <GI303B12B24BatteryTestReports reportData={reportDetailData} selectedAsset={selectedAsset} />,
    formGI303: <GI303BatteryMaintenance reportData={reportDetailData} selectedAsset={selectedAsset} />,
    formFicheB12: <GI303Report reportData={reportDetailData} selectedAsset={selectedAsset} />,
    formFicheB24: <GI305Report reportData={reportDetailData} selectedAsset={selectedAsset} />,
    suivimargingi335: <SudNicmanReport reportData={reportDetailData} selectedAsset={selectedAsset} />,
    relayTestForm: <RelayTest reportData={reportDetailData} selectedAsset={selectedAsset} />,
    CN_MultiYear_HoldClearElectrical: <RelayTest reportData={reportDetailData} selectedAsset={selectedAsset} />,
    insulationResistance: <InsulationResistance reportData={reportDetailData} selectedAsset={selectedAsset} />,
    CrossingHighwayReport: (
      <HighWayCrossing reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),
    GradeCrossingWarningReport: (
      <CrossingWarning reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    CPGradeCrossing: (
      <NewCPCrossingReport
        assetType={assetType}
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
      />
    ),

    HighwayGradeCrossing: (
      <NewCPCrossingReport
        assetType={assetType}
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
      />
    ),
    RelayReport: (
      <NewCPCrossingReport
        assetType={assetType}
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
      />
    ),
    sfrtaSwitchTests: (
      <SFRTA_SwitchTestsAndInspectionsReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
      />
    ),

    etrWeeklyReport: <ETR_WeeklyReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />,
    sfrtaLockingTests: (
      <SFRTA_LockingTestsAndInspectionsReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
      />
    ),
    sfrtaHotBoxDefectDetectorTests: (
      <SFRTA_DefectDetectorTestsAndInspectionsReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
      />
    ),
    fgaHBDReport: (
      <FGA_DefectDetectorTestsAndInspectionsReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
      />
    ),
    sfrtaBridgeLockingForm: (
      <SFRTA_BridgeTestsAndInspectionReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),
    sfrtacrossingWarnSysActivFailure: (
      <SFRTA_GradeCrossingActivationFailureReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        usersSignatures={usersSignatures}
      />
    ),
    sfrtaSignalIncidentResponse: (
      <SFRTA_SignalIncidentResponseRecord reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    nyswSignalIncidentResponse: (
      <NYSW_SignalIncidentResponseRecord
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        updateTestSchedule={updateTestSchedule}
      />
    ),
    TC_Generic: <ONR_GenericTestsReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />,
    fraBatteryCardForm: (
      <BatteryCardReports reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    //todo
    atlasInspectionConnection: (
      <ATLAS_InspectionConnectionReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    onrSwitchTests: (
      <ONR_SwitchTestsAndInspectionsReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    hbdTests: <HDBReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />,

    etr62590Report: (
      <ETRInspectionCard62590Report reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    etrGCPReport: <ETRGCPReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />,

    lirrHighwayGradeCrossing: (
      <LIRR_HighwayGradeCrossingReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        updateTestSchedule={updateTestSchedule}
        reportType={reportType}
      />
    ),

    lirrSwitchTestsAndInspection: (
      <LIRR_SwitchTestsAndInspectionReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        updateTestSchedule={updateTestSchedule}
        reportType={reportType}
      />
    ),

    eventRecorder: (
      <DefaultChecklistReports
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"Event Recorder Report"}
      />
    ),
    path_92DaysForm: (
      <Path_92daysInspectionReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"92 Days Inspection Report"}
        userList={userList}
      />
    ),
    hydrostaticHammerTest736days: (
      <MainReservoirReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"Hydrostatic Air Reservoir Test"}
      />
    ),
    periodic: (
      <DefaultChecklistReports
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"Periodic Locomotive Inspection Report"}
      />
    ),
    airbrake: (
      <AirBrakeReports
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"Locomotive AirBrake Inspection Report"}
      />
    ),
    LocomotiveEngineOEMAssetAppForm: (
      <DefaultChecklistReports
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"Locomotive Engine OEM Report"}
      />
    ),
    LocomotiveMechanicalInspectionAppForm33day: (
      <LomotiveInspection33daysReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    waiverType: <WaiverReports reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />,

    injectorChangeRecord: (
      <NonComplaintReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    noncompliantLocomotiveDescription: (
      <NonCompliantLocomotiveReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />
    ),

    nonCompliantBackToService: (
      <NonCompliantLocomotiveBackToService
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"Compliance Return Report"}
      />
    ),
    LocomotivePeriodicInspectionCheckOffList: (
      <LocomotiveCheckOffList
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={"LOCOMOTIVE PERIODIC INSPECTION CHECK OFF LIST"}
      />
    ),
    MaintenanceOEM_: (
      <OEMSingleReportContainer
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        testCode={param}
        title={"OEM Report"}
      />
    ),

    Highball_ShiftedLoadDetectorTest: (
      <ShiftedLoadDetectorReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        testCode={param}
      />
    ),

    highball_hbdTests: <HighBallHBDReport reportData={reportDetailData} selectedAsset={selectedAsset} selectedAssetId={selectedAssetId} />,

    sdmtsOverheadCatenarySystem: (
      <SDMTSInspectionReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        completeAsset={selectedAssetComplete}
        title={"Overhead Catenary System"}
      />
    ),

    sdmtsSDTIBiAnnualSubstationTest: (
      <BIAnnualTestReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        completeAsset={selectedAssetComplete}
        title={" SDTI BIANNUAL SUBSTATION TEST AND INSPECTION"}
      />
    ),
    tripStopReport: (
      <TripStopReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={
          <span>
            Signal Repairmen’s Inspection Report
            <br /> FRA Rule No. 236.576
            <br /> Roadway Element, Train Stop
          </span>
        }
      />
    ),
    PATH_ACTrackCircuitTest: (
      <TrackCircuitReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={
          <span>
            AC Track Circuit Report
            <br /> FRA Rule 236.56
          </span>
        }
      />
    ),
    Path_SEIIITrackCircuitTest: (
      <SEIII_TrackCircuitReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={
          <span>
            SEIII Track Circuit Report
            <br /> FRA Rule 236.56
          </span>
        }
      />
    ),
    PATH_DigicodeBranchTrackCircuit: (
      <DigiCodeRev5TrackCircuit_Report
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={
          <span>
            DigiCode Track Circuit Report
            <br /> FRA Rule 236.56
          </span>
        }
      />
    ),
    PATH_ST1DigicodeTrackCircuit: (
      <ST_1_DigiCodeTrackCircuit_Report
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={
          <span>
            ST-1 DigiCode Track Circuit Report
            <br /> FRA Rule 236.56
          </span>
        }
      />
    ),
    Columbia_LogicUnitValues: (
      <LogicUnitValues
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={
          <span>
            Logic Unit Values Report
            {/* <br /> FRA Rule 236.56 */}
          </span>
        }
      />
    ),
    HB_GradeCrossingAccidentReport: (
      <GradeCrossingAccidentReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        title={
          <span>
            HIGHWAY-RAIL GRADE CROSSING ACCIDENT/INCIDENT REPORT
            {/* <br /> FRA Rule 236.56 */}
          </span>
        }
      />
    ),
    path_12MonthsForm: (
      <Path_12daysInspectionReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        userList={userList}
        title={
          <span>
            12-Months Inspection Report
            {/* <br /> FRA Rule 236.56 */}
          </span>
        }
      />
    ),
    path_24MonthsForm: (
      <Path_24daysInspectionReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        userList={userList}
        title={
          <span>
            24-Months Inspection Report
            {/* <br /> FRA Rule 236.56 */}
          </span>
        }
      />
    ),
    path_36MonthsForm: (
      <Path_36daysInspectionReport
        reportData={reportDetailData}
        selectedAsset={selectedAsset}
        selectedAssetId={selectedAssetId}
        userList={userList}
        title={
          <span>
            36-Months Inspection Report
            {/* <br /> FRA Rule 236.56 */}
          </span>
        }
      />
    ),
  };
  let defaultReport = (
    <DefaultReport
      reportName={defaultReportNames[param]}
      reportData={reportDetailData}
      selectedAsset={selectedAsset}
      selectedAssetId={selectedAssetId}
    />
  );

  if (!obj[param]) {
    let FoundKey = Object.keys(obj).find((e) => param.includes(e));
    if (FoundKey) {
      return obj[FoundKey];
    }
  }
  return obj[param] ? obj[param] : defaultReport;
}



// WEBPACK FOOTER //
// ./src/components/Reports/sims/reportFilter.jsx